import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { IoClose } from "react-icons/io5";
import Qty from "./Qty";
//context
import {CartContext} from '../context/CartContext'
const CartItem = ({ item, onRemove }) => {
  const imageUrl = item?.image?.url;
  const {removeFromCart} = useContext(CartContext)
  return (
    <div className="flex items-center gap-4 p-4 mb-4 bg-gray-900 border border-gray-700 rounded-lg shadow-lg">
      {/* Product Image with Remove */}
      <div className="relative w-20 h-20 shrink-0">
        <Link to={`/product/${item.id}`}>
          <img
            src={`https://cms.sapnafashions.com${imageUrl}`}
            alt={item.title}
            className="w-full h-full object-cover rounded-md border border-gray-700"
          />
        </Link>
        <button
          onClick={() => removeFromCart?.(item.id)}
          className="absolute -top-2 -right-2 text-white bg-red-600 hover:bg-red-500 w-6 h-6 rounded-full flex items-center justify-center text-sm"
        >
          <IoClose />
        </button>
      </div>

      {/* Product Info */}
      <div className="flex flex-col flex-1 min-w-0">
        <Link
          to={`/product/${item.id}`}
          className="text-white font-medium text-sm sm:text-base hover:text-[#f24a04] line-clamp-2"
        >
          {item.title}
        </Link>

        {/* Quantity & Total */}
        <div className="mt-2 flex items-center justify-between text-sm text-gray-300">
          <Qty item={item} />
          <span className="font-medium">${item.price * item.amount}</span>
        </div>

        {/* Price per unit */}
        <div className="text-xs text-[#f24a04] mt-1">${item.price} / per piece</div>
      </div>
    </div>
  );
};

export default CartItem;